import React, { createContext, useContext, useState } from "react";
import COLORS from "./Colours";
import darkColors from "./darktheme";
import lightColors from "./lightcolour";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");

  const COLORS = theme === "light" ? lightColors : darkColors;

  const toggleTheme = () => {
    setTheme(prev => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ COLORS, theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeContext);
